/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A live project resource that references an organization-owned user_session_issuer.
 */
export type OrganizationUserSessionIssuerReference = {
  /**
   * The referencing resource id.
   */
  id: string;
  /**
   * The referencing resource display name.
   */
  name: string;
  /**
   * The owning project id.
   */
  projectId: string;
  /**
   * The owning project name.
   */
  projectName: string;
};

/** @internal */
export const OrganizationUserSessionIssuerReference$inboundSchema:
  z.ZodMiniType<OrganizationUserSessionIssuerReference, unknown> = z.pipe(
    z.object({
      id: z.string(),
      name: z.string(),
      project_id: z.string(),
      project_name: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "project_id": "projectId",
        "project_name": "projectName",
      });
    }),
  );

export function organizationUserSessionIssuerReferenceFromJSON(
  jsonString: string,
): SafeParseResult<OrganizationUserSessionIssuerReference, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      OrganizationUserSessionIssuerReference$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrganizationUserSessionIssuerReference' from JSON`,
  );
}
